export default __webpack_public_path__ + "ui/assets/img/half-20.svg";